<template>
    <div v-frag>
        <CardIeaAppMain>
            <v-col cols="12">
                <v-card class="mt-5" style="border:2px solid white !important; border-radius: 8px;">
                    <v-card-title class="d-flex justify-left pl-4">
                        <p style="word-break: keep-all !important;">Se envió un correo con tus credenciales</p>
                    </v-card-title>
                    <v-card-text>
                        <v-container fluid>
                            <v-col cols="12" sm="12" md="8">
                                <span>Usuario:</span>
                                <v-text-field 
                                    v-model="user" 
                                    disabled
                                    hide-details="auto"
                                    class="text-responsive"
                                    full-width
                                    style="margin-top: -15px;"
                                ></v-text-field>
                            </v-col>
                            <v-row style="margin-top: 10px;">
                                <v-col class="ms-2" cols="12" sm="12" md="4">
                                    <span>Password:</span>
                                    <v-text-field 
                                        v-model="password" 
                                        disabled
                                        hide-details="auto"
                                        class="text-responsive"
                                        full-width
                                        style="margin-top: -5px; margin-bottom: 20px;"
                                    ></v-text-field>
                                    <v-alert dense type="warning" style="margin-left: -20px;">
                                        Esta contraseña es temporal, recomendamos cambiarla por seguridad.
                                    </v-alert>
                                </v-col>
                                <v-col class="mt-4" cols="12" sm="12" md="6">
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="4">
                                    <code class="text-h6">https://public.terminalasecundaria.ar/login</code>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-btn class="ml-3" fab x-small @click="copiarUrl">
                                        <v-icon small>mdi-content-copy</v-icon>
                                    </v-btn>
                                    <v-btn @click="irLogin()" class="ms-2 white--text rounded-lg" depressed color="btnSuccess">
                                        Ir a Login
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </CardIeaAppMain>
    </div>
</template>

<script>

import CardIeaAppMain from "../../components/CardIeaAppMain";
export default {
    components: {
        CardIeaAppMain
    },
    data() {
        return {
            user: '',
            password: ''
        }
    },
    methods: {
        irLogin() {
            this.$router.push({ name: 'Login' });
        },
        copiarUrl() {
            navigator.clipboard.writeText("https://public.terminalasecundaria.ar/login")
        },
        async validarHash() {
            if (this.$route.query.makehash && this.$route.query.makehashprefix && this.$route.query.prefix) {
                let url = "circuito/validate";
                await this.$API
                    .post({
                        url: url,
                        data: {
                            hash: this.$route.query.makehash,
                            prefix: this.$route.query.prefix,
                            makehashprefix:this.$route.query.makehashprefix
                        }
                    }).then((res) => {
                        if (res.estado) {
                            this.user = res.alumno.Usuario
                            this.password = res.alumno.datoPass
                        } else {
                            this.$router.push({ name: 'Login' })

                        }
                    });
            } else {
                this.$router.push({ name: 'Login' })
            }
        }
    },
    mounted() {
        this.validarHash()
    }
}
</script>
<style scoped>
    ::v-deep .theme--light.v-card {
        background-color: #003d6e !important;
        color: white !important;
    }
    ::v-deep .theme--light.v-card > .v-card__text, .theme--light.v-card > .v-card__subtitle {
        color: white !important;
    }
    ::v-deep .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
        color: rgba(0, 0, 0, 0.38);
        background-color: white !important;
        margin-left: -10px;
        border-radius: 4px;
    }

    ::v-deep .v-text-field {
            max-width: 50% !important;
    }
    @media (max-width: 600px) {  /* Tamaños de pantalla pequeños */
        .col-8 {
        flex: 0 0 100%;
        max-width: 100%;
        }

        .text-responsive {
            width: 100% !important; /* Ocupa todo el ancho en móviles */
            font-size: 12px !important; /* Reduce el tamaño del texto si es necesario */
        }

        .v-text-field {
            max-width: 100% !important;
        }

        ::v-deep .col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
            width: 100%;
            padding: 5px !important;
        }

        ::v-deep .text-h6 {
            font-size: 14px !important;
            font-weight: 800;
            line-height: 2rem;
            letter-spacing: 0.0125em !important;
            font-family: "Roboto", sans-serif !important;
        }

    }


</style>